<template>
  <div class="Guard2InspectorForm" v-if="reserveInfo">
    <!-- if edit -->
    <el-form :model="guard2Form" ref="guard2Form" v-if="!isView" :disabled="!editable">
      <CardTable>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.inspector") }}</div>
          <div class="value" v-if="editable">{{ getUserProfile().userName }}</div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.carring") }}</div>
          <div class="value">
            {{ (reserveInfo.carringData ?? []).length > 0 ? $t("pages.wording.exist") : $t("pages.wording.dontExist") }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.entourage") }}</div>
          <div class="value">
            {{
              (reserveInfo.entourageData ?? []).length > 0 ? $t("pages.wording.exist") : $t("pages.wording.dontExist")
            }}
          </div>
        </div>
        <div class="card-item" v-if="isReserveForERPRelease(reserveInfo.reserveData.reserveType) === false">
          <el-form-item
            :label="$t('pages.wording.releaseStuff')"
            prop="needAddReleaseItemManually.resValue"
            :rules="{ required: true, message: $t('pages.wording.requiredInput'), trigger: 'blur' }"
          >
            <el-radio-group
              v-model="guard2Form.needAddReleaseItemManually.resValue"
              :placeholder="$t('pages.wording.placeholderSelect')"
            >
              <el-radio label="N">{{ $t("pages.wording.dontExist") }}</el-radio>
              <el-radio label="Y">{{ $t("pages.wording.exist") }}</el-radio>
            </el-radio-group>
          </el-form-item>
        </div>
        <!--手動新增放行單號 START-->
        <div
          class="card-item addForm"
          v-if="
            guard2Form.needAddReleaseItemManually.resValue === 'Y' &&
            isReserveForERPRelease(reserveInfo.reserveData.reserveType) === false
          "
        >
          <div v-for="(item, index) in guard2Form.newReleaseList" :key="index">
            <el-form-item
              :label="$t('pages.wording.releaseNo') + ' ' + (index + 1)"
              :prop="'newReleaseList.' + index + '.resValue'"
              :rules="{
                required: true,
                message: $t('pages.wording.requiredInput'),
                trigger: 'blur',
              }"
            >
              <div class="input-append">
                <el-input v-model="item.resValue" :placeholder="$t('pages.wording.placeholderInput')"></el-input>
                <el-button
                  id="deleteFormButton"
                  type="danger"
                  icon="el-icon-delete"
                  plain
                  @click="deleteNormalReleaseOrder(index)"
                ></el-button>
              </div>
            </el-form-item>
          </div>
          <el-form-item label="">
            <el-button id="addFormButton" icon="el-icon-plus" type="primary" plain @click="addNormalReleaseOrder">{{
              $t("pages.wording.addReleaseData")
            }}</el-button>
          </el-form-item>
        </div>
        <!--手動新增放行單號 END-->
        <div class="card-item" v-if="isReserveForERPRelease(reserveInfo.reserveData.reserveType)">
          <div class="label">{{ $t("pages.wording.releaseListTitle") }}</div>
          <div class="value">
            <span class="pdf-button" @click="releaseListClick">
              <span><i class="el-icon-document"></i>{{ $t("pages.wording.releaseList") }}</span>
            </span>
          </div>
        </div>
        <!--不合格原因-->
        <div class="card-item">
          <el-form-item :label="$t('pages.wording.failReason')" prop="failReason.resValue">
            <el-select v-model="guard2Form.failReason.resValue" :placeholder="$t('pages.wording.placeholderSelect')">
              <el-option
                v-for="item in $store.getters.sortDDL(guard2Form.failReason.option)"
                :key="item.code"
                :label="item[$i18n.locale]"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
        <!--備註-->
        <div class="card-item">
          <el-form-item :label="$t('pages.wording.remark')">
            <el-input v-model="guard2Form.remark" :placeholder="$t('pages.wording.placeholderInput')"></el-input>
          </el-form-item>
        </div>
        <!--逾期說明-->
        <div class="card-item" v-if="stayDelay.diff">
          <el-form-item
            :label="$t('pages.wording.delayReason')"
            prop="delayReason.resValue"
            :rules="{
              required: true,
              message: $t('pages.wording.requiredInput'),
              trigger: 'blur',
            }"
          >
            <el-select v-model="guard2Form.delayReason.resValue" :placeholder="$t('pages.wording.placeholderSelect')">
              <el-option
                v-for="item in $store.getters.sortDDL(guard2Form.delayReason.option)"
                :key="item.code"
                :label="item[$i18n.locale]"
                :value="item.code"
              >
              </el-option>
            </el-select>
          </el-form-item>
        </div>
      </CardTable>
    </el-form>
    <!-- if view -->
    <el-form :model="guard2Form" ref="guard2Form" v-else>
      <CardTable>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.inspector") }}</div>
          <div class="value">
            {{
              reserveInfo.inspectData.in1InspectRecord === null
                ? ""
                : reserveInfo.inspectData.in1InspectRecord.inspectOperator
            }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.checkTime") }}</div>
          <div class="value">
            {{ viewInspectDateTime }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.carring") }}</div>
          <div class="value">
            {{ (reserveInfo.carringData ?? []).length > 0 ? $t("pages.wording.exist") : $t("pages.wording.dontExist") }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.entourage") }}</div>
          <div class="value">
            {{
              (reserveInfo.entourageData ?? []).length > 0 ? $t("pages.wording.exist") : $t("pages.wording.dontExist")
            }}
          </div>
        </div>
        <!--手動新增放行單號-->
        <div class="card-item" v-if="isReserveForERPRelease(reserveInfo.reserveData.reserveType) === false">
          <div class="label">{{ $t("pages.wording.releaseStuff") }}</div>
          <div class="value">
            {{ hasAddNewRelease.resValue == "Y" ? $t("pages.wording.exist") : $t("pages.wording.dontExist") }}
          </div>
        </div>
        <div class="card-item addForm" v-if="viewAddReleaseList != null && viewAddReleaseList.length > 0">
          <div class="el-form-item" v-for="(item, index) in viewAddReleaseList" :key="index">
            <div class="label">{{ $t("pages.wording.releaseNo") + " " + (index + 1) }}</div>
            <div class="value">{{ item.resValue }}</div>
          </div>
        </div>
        <div class="card-item" v-if="isReserveForERPRelease(reserveInfo.reserveData.reserveType)">
          <div class="label">{{ $t("pages.wording.releaseListTitle") }}</div>
          <div class="value">
            <span class="pdf-button" @click="releaseListClick">
              <span><i class="el-icon-document"></i>{{ $t("pages.wording.releaseList") }}</span>
            </span>
          </div>
        </div>
        <div class="card-item" v-if="reserveInfo.inspectData?.in1InspectRecord?.inspectStatus === 'FAIL'">
          <div class="label">{{ $t("pages.wording.failReason") }}</div>
          <div class="value">
            <i class="el-icon-document"></i>
            {{ viewFailReason }}
          </div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.remark") }}</div>
          <div class="value">{{ reserveInfo.inspectData.in1InspectRecord?.inspectRemark }}</div>
        </div>
        <div class="card-item">
          <div class="label">{{ $t("pages.wording.delayReason") }}</div>
          <div class="value">{{ viewDelayReason }}</div>
        </div>
      </CardTable>
    </el-form>
  </div>
</template>
<script>
import { mapGetters } from "vuex"
import { utils } from "@/utils/utils.js"
import CardTable from "@/components/common/CardTable.vue"

export default {
  name: "Guard2InspectorForm",
  components: {
    CardTable,
  },
  props: {
    editable: {
      type: Boolean,
    },
    isView: {
      type: Boolean,
    },
    reserveInfo: {
      type: Object,
    },
  },
  data() {
    return {
      guard2Form: {
        delayReason: {
          // item: "s2-1",
          option: [],
          resValue: null,
          description: "DelayDescription",
          result: true,
        },
        needAddReleaseItemManually: {
          // item: "s2-2",
          option: [],
          resValue: "N",
          description: "ReleaseStuff",
          result: true,
        },
        failReason: {
          item: "s2-5",
          option: [],
          resValue: null,
          description: "UnqualifiedReason",
          result: false,
        },
        remark: null,
        newReleaseList: [],
      },
    }
  },
  created() {
    this.init()
  },
  methods: {
    ...mapGetters(["getUserProfile"]),
    init() {
      this.getDelayReasonBase()
      this.getFailReasonBase()
    },
    addNormalReleaseOrder() {
      let newReleaseOrder = {
        // item: "s2-3",
        option: [],
        resValue: null,
        description: "ReleaseNo",
        result: true,
      }
      this.guard2Form.newReleaseList.push(newReleaseOrder)
    },
    deleteNormalReleaseOrder(raw) {
      this.guard2Form.newReleaseList.splice(raw, 1)
    },
    isReserveForERPRelease(reserveType) {
      return this.$global.erpReserveType.includes(reserveType)
    },
    getInspectData() {
      let inspectItem = [
        {
          //逾期說明
          itemType: "select",
          item: this.guard2Form.delayReason.item,
          description: this.guard2Form.delayReason.description,
          resValue: this.guard2Form.delayReason.resValue,
        },
        {
          //放行物品
          itemType: "radio",
          item: this.guard2Form.needAddReleaseItemManually.item,
          description: this.guard2Form.needAddReleaseItemManually.description,
          resValue: this.guard2Form.needAddReleaseItemManually.resValue,
        },
      ]
      if (this.guard2Form.needAddReleaseItemManually.resValue === "Y") {
        this.guard2Form.newReleaseList.forEach((item) => {
          let data = {
            itemType: "input",
            item: item.item,
            description: "ReleaseNo",
            resValue: item.resValue,
          }
          inspectItem.push(data)
        })
      }
      return {
        success: true,
        formData: {
          remark: this.guard2Form.remark,
          inspectItem: inspectItem,
          isDelay: this.stayDelay.diff,
          delayReason: this.guard2Form.delayReason.resValue,
          failReason: this.guard2Form.failReason.resValue,
        },
      }
    },
    releaseListClick() {
      this.$emit("releaseListClick")
    },
    async getDelayReasonBase() {
      this.guard2Form.delayReason.option = await utils.getCodeListWithCulture(
        this.reserveInfo.reserveData.reserveRegion,
        this.reserveInfo.reserveData.reserveArea,
        "delayReason"
      )
    },
    async getFailReasonBase() {
      this.guard2Form.failReason.option = await utils.getCodeListWithCulture(
        this.reserveInfo.reserveData.reserveRegion,
        this.reserveInfo.reserveData.reserveArea,
        "entryNotPassReason"
      )
    },
  },
  computed: {
    stayDelay() {
      let startTime = utils.newDateFormat(
        utils.getFormateDateTime("DateTime", this.reserveInfo.reserveData.enteringDatetime)
      )
      let currentTime = utils.getDateTime(new Date())
      let endTime = utils.newDateFormat(currentTime[0] + " " + currentTime[1])

      let diff = parseInt(endTime - startTime) / 1000 / 60 //minute
      let d = Math.floor(diff / 60 / 24) < 1 ? "00" : Math.floor(diff / 60 / 24)
      let h = Math.floor(diff / 60) < 10 ? "0" + Math.floor(diff / 60) : Math.floor(diff / 60)
      let m = diff % 60 < 10 ? "0" + (diff % 60) : diff % 60

      let result = {
        diff: diff > 30 ? true : false,
        time: h + ":" + m,
      }
      return result
    },
    viewFailReason() {
      if (this.reserveInfo.inspectData == null || this.reserveInfo.inspectData.in1CheckItems == null) {
        return ""
      }
      let item = this.reserveInfo.inspectData.in1CheckItem.find((c) => c.description === "UnqualifiedReason")
      return this.$store.getters.getSysCodeText("entryNotPassReason", item.resValue)
    },
    viewDelayReason() {
      if (this.reserveInfo.inspectData == null || this.reserveInfo.inspectData.in1CheckItems == null) {
        return ""
      }
      let item = this.reserveInfo.inspectData.in1CheckItems.find((c) => c.description === "DelayDescription")

      return this.$store.getters.getSysCodeText("delayReason", item.resValue)
    },
    hasAddNewRelease() {
      if (this.reserveInfo.inspectData == null || this.reserveInfo.inspectData.in1CheckItems == null) {
        return ""
      }
      let item = this.reserveInfo.inspectData.in1CheckItems.find((c) => c.description === "ReleaseStuff")
      return item
    },
    viewAddReleaseList() {
      if (this.reserveInfo.inspectData == null || this.reserveInfo.inspectData.in1CheckItems == null) {
        return null
      }
      let item = this.reserveInfo.inspectData.in1CheckItems.filter((c) => c.description === "ReleaseNo")
      return item
    },
    viewInspectDateTime() {
      return this.reserveInfo.inspectData.in1InspectRecord === null
        ? ""
        : utils.parseISOStringToDateTime(this.reserveInfo.inspectData.in1InspectRecord.inspectDatetime)
    },
  },
}
</script>

<style scoped>
.checkAll-group .el-checkbox-group {
  padding-left: 24px;
}

.checkAll-group .el-checkbox-group .el-checkbox {
  display: block;
}

.input-append {
  display: flex;
}

.input-append .el-input {
  margin-right: 8px;
}

.card-item.addForm {
  display: block;
}

.card-item.addForm ::v-deep .el-form-item .el-form-item__content {
  width: 100%;
}

.card-item.addForm ::v-deep .el-form-item .el-form-item__content #addFormButton,
.card-item.addForm ::v-deep .el-form-item .el-form-item__content #addFormButton:hover {
  width: 100%;
  color: var(--blue500);
  border-color: var(--blue500);
  background: transparent;
}

.el-form-item__content #addFormButton:hover {
  opacity: 0.7;
}

.card-item.addForm ::v-deep .el-form-item .el-form-item__content #deleteFormButton,
.card-item.addForm ::v-deep .el-form-item .el-form-item__content #deleteFormButton:hover {
  color: #f56c6c;
  background: transparent;
  border: none;
  padding: 12px 8px;
}

.CardTable .card-item.addForm ::v-deep .el-form-item .el-form-item__content #deleteFormButton:hover {
  opacity: 0.7;
}

.CardTable .card-item.addForm ::v-deep .el-form-item .el-form-item__content #deleteFormButton i {
  font-size: 18px;
}

.CardTable .card-item ::v-deep .el-form-item .el-form-item__content .el-radio {
  margin-bottom: 0;
}

.pdf-button {
  color: var(--blue500);
  font-size: var(--button-font-size);
  line-height: var(--button-line-height);
  font-weight: 700;
  cursor: pointer;
  display: block;
  margin-bottom: 8px;
}

.pdf-button i {
  font-size: 18px;
  margin-right: 4px;
}
</style>
